import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'pt-list-formatter-renderer',
  template: `<span>{{params.value}}</span>`,
  styles: [``]
})
export class ListFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

}
